import { SxProps, Theme } from '@mui/material';

export const AccountSummaryPersonalInfoLabelSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-small)',
	color: '#929292',
});

export const AccountSummaryPersonalInfoValueSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body)',
	color: '#2C2C2C',
	fontWeight: 600,
});

export const AccountSummaryPersonalDividerSX: SxProps<Theme> = {
	display: { xs: 'none', md: 'block' },
};

